// /src/App.js
import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./main/HomePage";
import About from "./about/About";
import Works from "./works/Works";
import Experience from "./experience/Experience";
import Contact from "./contact/Contact";
import NASA from "./works/detailed/NASA/NASA";
import VisioQuest from "./works/detailed/VisioQuest/VisioQuest";
import MagicalBedtime from "./works/detailed/MagicalBedtime/MagicalBedtime";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<About />} />
          <Route path="/experience" element={<Experience />} />
          <Route path="/works" element={<Works />} />
          <Route path="/contact" element={<Contact />} />

          <Route path="/works/nasa-images" element={<NASA />} />
          <Route path="/works/visioquest" element={<VisioQuest />} />
          <Route
            path="/works/my-magical-bedtime"
            element={<MagicalBedtime />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
